import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { TextQuestionEntry } from '@entscheidungsnavi/api-types';
import { MatFormField, MatLabel } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { ReactiveFormsModule } from '@angular/forms';
import { FORWARD_CONTROL_CONTAINER } from '../../../form-elements';

@Component({
  selector: 'dt-questionnaire-question-text',
  templateUrl: './questionnaire-text.component.html',
  styleUrls: ['./questionnaire-text.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  viewProviders: [FORWARD_CONTROL_CONTAINER],
  imports: [MatFormField, MatLabel, MatInput, ReactiveFormsModule],
})
export class QuestionnaireQuestionTextComponent {
  @Input()
  entry: TextQuestionEntry;

  @Input()
  formIndex: number;
}
